import React from "react";

const Cell = ({data}) => {
    return (
        <div className="min-w-24 max-w-24 border-b border-r border-black font-semibold p-1.4 text-sm overflow-x-hidden">
            {data}
        </div>
    )
} 

export default Cell;